export const getFirstAndLastItem = (arr: string[]): string[] => {
  return arr.length > 2 ? [arr[0], arr[arr.length - 1]] : arr
}

export const removeDuplicate = (array: any[]): any[] =>
  Array.from(new Set(array))
